'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseTwoAxisGraphPanelDirective=require('../../../../../dist-es6/client/directives/statisticsPanels/baseTwoAxisGraphPanelDirective');
const BaseTwoAxisGraphPanelDirectiveController=BaseTwoAxisGraphPanelDirective.DirectiveController;let

DaysSinceLastIncidentGraphPanelDirective=class DaysSinceLastIncidentGraphPanelDirective extends BaseTwoAxisGraphPanelDirective{
get controller(){return DaysSinceLastIncidentGraphPanelDirectiveController}};let


DaysSinceLastIncidentGraphPanelDirectiveController=class DaysSinceLastIncidentGraphPanelDirectiveController extends BaseTwoAxisGraphPanelDirectiveController{
constructor($scope,$timeout,$element,elementService){
super($scope,$timeout,$element,elementService);

this._drawPath=d3.svg.line().
interpolate('linear-closed').
x(([time,dayDifference]=[0,0])=>this._xScale(time)).
y(([time,dayDifference]=[0,0])=>this._yScale(dayDifference));

this._flatLineToStart=d3.svg.line().
interpolate('linear-closed').
x(([time,dayDifference]=[0,0])=>this._xScale(time)).
y(([time,dayDifference]=[0,0])=>this._yScale(0));

this._graphAreaInnerPadding.left=0;
this._yScaleNiceDomainRounding=5;
this._numYAxisTicks=5;
}


_setupGraphs(){
if(!_.exists(this._gradient)){
this._gradient=this._svgDefs.
append('linearGradient').
attr({
id:`gradient-${this.panelId}`,
x1:'0%',
x2:'0%',
y1:'0%',
y2:'100%'});


this._gradient.append('stop').
attr({
"stop-color":'#62BAEA',
offset:'0%'});


this._gradient.append('stop').
attr({
"stop-color":'#DAF2FF',
offset:'100%'});

}
}






_setupInitialState(){
this._graphedPath=this._graphAreaGroup.
selectAll('path').
data([this.context]);

this._graphedPath.
enter().
append('path').
attr({
d:d=>this._flatLineToStart(d),
fill:`url(#gradient-${this.panelId})`,
"clip-path":`url(#clip-path-${this.panelId})`});


this._graphedPath.
exit().
remove();

this._graphAreaClipPathRect.
attr({
width:this._xScale.range()[1]-0.5,
height:this._yScale.range()[0]-0.5});

}


_updateState(isResizing){
const pathWithOrWithoutTransition=this.preventAnimations||isResizing?
this._graphedPath:
this._graphedPath.transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration);

pathWithOrWithoutTransition.
attr({
d:d=>this._drawPath(d)});

}};






module.exports=DaysSinceLastIncidentGraphPanelDirective;
//# sourceMappingURL=daysSinceLastIncidentGraphPanelDirective.js.map
